import { request, success, failure, SCHEDULER_REQUEST } from "./utilities";
import {
  getSchedulerData,
  addSchedulerEvent,
  deleteSchedulerEvent,
  getProjectLookup,
  getUserLookup,
  getDepartmentLookup,
  getTeamLookup,
  getUserProjectsTask,
  getProjectUsersTask,
  getTaskDetailsApi,
  updateTaskDueDate as updateTaskDueDateAPI,
} from "../api";
// export function getSchedulerDataList() {
//   return (dispatch) => {
//     dispatch(request(SCHEDULER_REQUEST.SCHEDULER_DATA_REQUEST));
//     // Create an object to store all API responses
//     const apiData = {};
//     // Define all promises
//     const promises = [
//       getUsers({}),
//       getProjects({}),
//       getTasks({})
//     ];
//     // Execute all promises in parallel
//     Promise.all(promises)
//       .then(([usersResponse, projectsResponse, tasksResponse]) => {
//         // Store API responses
//         apiData.users = usersResponse.data;
//         apiData.projects = projectsResponse.data;
//         apiData.tasks = tasksResponse.data;
//         // Your existing mock response
//         var response = {
//           resourceData: [/* Your existing resource data */],
//           roomData: [/* Your existing room data */],
//           resourceDataProject: [/* Your existing project data */],
//           userData: [/* Your existing user data */],
//           projectData: [/* Your existing project data */],
//           projects_data: [/* Your existing projects data */],
//           user_data: [/* Your existing user data */],
//           user_ungrouped: [/* Your existing ungrouped user data */],
//           // Add new data from API responses
//           apiUsers: apiData.users,
//           apiProjects: apiData.projects,
//           apiTasks: apiData.tasks
//         };
//         dispatch(success(SCHEDULER_REQUEST.SCHEDULER_DATA_SUCCESS, response));
//       })
//       .catch(error => {
//         dispatch(failure(
//           SCHEDULER_REQUEST.SCHEDULER_DATA_FAILURE,
//           error?.response?.data?.title || error.message
//         ));
//       });
//   };
// }
// Add the new action
export function getTaskDetails(eventDetails) {
  return (dispatch) => {
    dispatch(request(SCHEDULER_REQUEST.GET_TASK_DETAILS_REQUEST));

    // This will be replaced with API call
    // For now using mock data
    // const taskData = {
    //   task: {
    //     id: eventDetails.Id || 103060,
    //     taskId: eventDetails.Id || 103060,
    //     taskTypeId: 35,
    //     severityId: 1,
    //     currentTaskBoardId: 1243,
    //     title: eventDetails.Subject || "usama task",
    //     description: eventDetails.Description || "",
    //     attachmentCount: 0,
    //     commentsCount: 0,
    //     currentTaskBoardTypeId: 2,
    //     reportedById: 627,
    //     dueDate: eventDetails.EndTime || "2025-02-20T00:00:00",
    //     currentEstimatedTime: 28800,
    //     totalTimeSpent: null,
    //     assignee: eventDetails.assignee || "Usama Ikram",
    //     reportedBy: "Irfan Malik",
    //     currentAssigneeId: eventDetails.UserId || 760,
    //     reportedPicUrl: null,
    //     taskDocuments: null
    //   },
    //   project: {
    //     projectId: eventDetails.ProjectId || 635,
    //     projectCategory: {
    //       projectCategoryId: 9,
    //       title: "IT ERP Solution"
    //     },
    //     projectLeader: null,
    //     projectTeam: null,
    //     status: {
    //       lookupId: 54,
    //       lookupTitle: "New",
    //       lookupValue: "New"
    //     },
    //     projectCode: "200",
    //     projectName: "Covis",
    //     projectLogo: null,
    //     description: "testing",
    //     webisteURL: "https://pmsdev.visioncollab.com/",
    //     currency: {
    //       lookupId: 53,
    //       lookupTitle: "US Dollar",
    //       lookupValue: "$"
    //     },
    //     price: 30000,
    //     startDate: "2024-10-01T00:00:00",
    //     endDate: "2024-11-08T00:00:00",
    //     createdBy: "Irfan Malik",
    //     createdDate: "2024-10-01T11:20:00",
    //     projectTeamMembers: [
    //       {
    //         userId: 627,
    //         username: "Irfan Malik",
    //         email: "irfanmalik@xevensolutions.com",
    //         profilePicture: null
    //       },
    //       {
    //         userId: 760,
    //         username: "Usama Ikram",
    //         email: "usamaikram@xevensolutions.com",
    //         profilePicture: null
    //       }
    //     ],
    //     totalProjectTasks: 7,
    //     totalCompletedProjectTasks: 0,
    //     activeMilesStoneId: 423,
    //     projectlogoUrl: null
    //   },
    //   taskIndex: 2
    // };

    // Later this will be an API call:
    const promises = [getTaskDetailsApi(eventDetails.Id)];
    Promise.all(promises)
      .then(([taskDetails]) => {
        dispatch(
          success(SCHEDULER_REQUEST.GET_TASK_DETAILS_SUCCESS, taskDetails.data)
        );
      })
      .catch((error) => {
        dispatch(
          failure(
            SCHEDULER_REQUEST.GET_TASK_DETAILS_FAILURE,
            error?.response?.data?.title || error.message
          )
        );
      });

    // For now, dispatch success with mock data
    //dispatch(success(SCHEDULER_REQUEST.GET_TASK_DETAILS_SUCCESS, taskData));
  };
}
export function getSchedulerDataList(filters, token) {
  return (dispatch) => {
    dispatch(request(SCHEDULER_REQUEST.SCHEDULER_DATA_REQUEST));
    // Create an object to store all API responses
    const promises = [
      getUserProjectsTask(filters, token),
      getProjectUsersTask(filters, token),
    ];

    Promise.all(promises)
      .then(([userProjectsTask, projectUsersTask]) => {
        const result = userProjectsTask.data;
        const resultP = projectUsersTask.data;

        // Your existing mock response
        var response = {
          resourceData: result.taskData,
          roomData: [/ Your existing room data /],
          resourceDataProject: resultP.taskData,
          userData: result.parentNode,
          projectData: result.childNode,
          projects_data: resultP.parentNode,
          user_data: resultP.childNode,
          user_ungrouped: [/ Your existing ungrouped user data /],
        };
        dispatch(success(SCHEDULER_REQUEST.SCHEDULER_DATA_SUCCESS, response));
      })
      .catch((error) => {
        dispatch(
          failure(
            SCHEDULER_REQUEST.SCHEDULER_DATA_FAILURE,
            error?.response?.data?.title || error.message
          )
        );
      });
  };
}
export function updateTaskDueDate(payload, token) {
  return (dispatch) => {
    dispatch(request(SCHEDULER_REQUEST.UPDATE_TASK_DUEDATE_REQUEST));

    return updateTaskDueDateAPI(payload, token)
      .then((res) => {
        dispatch(
          success(SCHEDULER_REQUEST.UPDATE_TASK_DUEDATE_SUCCESS, res.data)
        );
        return res.data;
      })
      .catch((error) => {
        dispatch(
          failure(
            SCHEDULER_REQUEST.UPDATE_TASK_DUEDATE_FAILURE,
            error?.response?.data?.title || error.message
          )
        );
        throw error;
      });
  };
}

export function addNewSchedulerEvent(schedulerData, close) {
  return (dispatch) => {
    var data = {
      Id: 65,
      Subject: "Testing data is here",
      StartTime: "2018-04-02T00:00:00.000Z",
      EndTime: "2018-04-14T00:00:00.000Z",
      IsAllDay: true,
      PerDayHours: 2,
      UserId: 1,
      ProjectId: 1,
    };
    dispatch(success(SCHEDULER_REQUEST.ADD_SCHEDULER_EVENT_SUCCESS, data));
    if (close) {
      close();
    }
    // dispatch(request(SCHEDULER_REQUEST.ADD_SCHEDULER_EVENT_REQUEST))
    // addSchedulerEvent(schedulerData).then(
    //     response => {
    //         if (response.data.status === 1) {
    //             dispatch(success(SCHEDULER_REQUEST.ADD_SCHEDULER_EVENT_SUCCESS, response.data.data))
    //             if (close) {
    //                 close();
    //             }
    //             dispatch(getSchedulerDataList())
    //         }
    //         else {
    //             dispatch(failure(SCHEDULER_REQUEST.ADD_SCHEDULER_EVENT_FAILURE, response.data.message))
    //         }
    //     },
    //     error => {
    //         dispatch(failure(SCHEDULER_REQUEST.ADD_SCHEDULER_EVENT_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
    //     }
    // )
  };
}
export function editSchedulerEvent(schedulerData, close) {
  return (dispatch) => {
    dispatch(request(SCHEDULER_REQUEST.EDIT_SCHEDULER_EVENT_REQUEST));
    addSchedulerEvent(schedulerData).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(
              SCHEDULER_REQUEST.EDIT_SCHEDULER_EVENT_SUCCESS,
              response.data.data
            )
          );
          if (close) {
            close();
          }
          dispatch(getSchedulerDataList());
        } else {
          dispatch(
            failure(
              SCHEDULER_REQUEST.EDIT_SCHEDULER_EVENT_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            SCHEDULER_REQUEST.EDIT_SCHEDULER_EVENT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
export function removeSchedulerEvent(schedulerData) {
  return (dispatch) => {
    dispatch(
      success(
        SCHEDULER_REQUEST.DELETE_SCHEDULER_EVENT_SUCCESS,
        schedulerData.Id
      )
    );
    // dispatch(request(SCHEDULER_REQUEST.DELETE_SCHEDULER_EVENT_REQUEST))
    // deleteSchedulerEvent(schedulerData).then(
    //     response => {
    //         if (response.data.status === 1) {
    //             dispatch(success(SCHEDULER_REQUEST.DELETE_SCHEDULER_EVENT_SUCCESS, response.data.data))
    //         }
    //         else {
    //             dispatch(failure(SCHEDULER_REQUEST.DELETE_SCHEDULER_EVENT_FAILURE, response.data.message))
    //         }
    //     },
    //     error => {
    //         dispatch(failure(SCHEDULER_REQUEST.DELETE_SCHEDULER_EVENT_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
    //     }
    // )
  };
}
export function getProjectLookupData(organizationId, token) {
  return (dispatch) => {
    getProjectLookup(organizationId, token).then((res) => {
      dispatch(success(SCHEDULER_REQUEST.GET_PROJECT_LOOKUP_SUCCESS, res.data));
    });
  };
}
export function getUserLookupData(organizationId, token) {
  return (dispatch) => {
    getUserLookup(organizationId, token).then((res) => {
      dispatch(success(SCHEDULER_REQUEST.GET_USER_LOOKUP_SUCCESS, res.data));
    });
  };
}
export function getDepartmentLookupData() {
  return (dispatch) => {
    getDepartmentLookup().then((res) => {
      dispatch(
        success(SCHEDULER_REQUEST.GET_DEPARTMENT_LOOKUP_SUCCESS, res.data)
      );
    });
  };
}
export function getTeamLookupData() {
  return (dispatch) => {
    getTeamLookup().then((res) => {
      dispatch(success(SCHEDULER_REQUEST.GET_TEAM_LOOKUP_SUCCESS, res.data));
    });
  };
}
